import script from "./Tit.vue?vue&type=script&setup=true&lang=js"
export * from "./Tit.vue?vue&type=script&setup=true&lang=js"

import "./Tit.vue?vue&type=style&index=0&id=00a37b5e&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a37b5e"]])

export default __exports__